'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = require('preact');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _CartItem = require('./CartItem');

var _CartItem2 = _interopRequireDefault(_CartItem);

var _helpers = require('../../global/helpers/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//require('preact/devtools');

var axiosInstance = _axios2.default.create({
  headers: {
    Pragma: 'no-cache',
    'X-Requested-With': 'XMLHttpRequest'
  }
});

var Cart = function (_Component) {
  (0, _inherits3.default)(Cart, _Component);

  function Cart() {
    (0, _classCallCheck3.default)(this, Cart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this));

    _this.state = {
      items: [],
      quantity: 0,
      total_price: 0,
      cartIsOpen: false
    };

    _this.fetchCart = _this.fetchCart.bind(_this);
    _this.openCart = _this.openCart.bind(_this);
    _this.closeCart = _this.closeCart.bind(_this);
    _this.updateCart = _this.updateCart.bind(_this);
    _this.addToCart = _this.addToCart.bind(_this);
    _this.updateNavCount = _this.updateNavCount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Cart, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.fetchCart();
    }
  }, {
    key: 'fetchCart',
    value: function fetchCart() {
      var _this2 = this;

      _axios2.default.get('/cart.json').then(function (res) {
        _this2.updateCart(res.data);
        return true;
      }).catch(function (err) {
        console.log(err);
      });
    }
  }, {
    key: 'addToCart',
    value: function addToCart(itemId, quantity) {
      var _this3 = this;

      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      axiosInstance.post('/cart/add.js', {
        quantity: quantity,
        id: itemId,
        properties: properties
      }).then(function (res) {
        _this3.fetchCart();
        _this3.openCart();
        return true;
      }).catch(function (err) {
        alert(err.response.data.description);
      });
    }
  }, {
    key: 'updateCart',
    value: function updateCart(cart) {
      var _this4 = this;

      var quantity = 0;
      var items = cart.items.map(function (item) {
        item.price = item.price;
        quantity += item.quantity;
        return item;
      });

      this.setState({
        items: items,
        quantity: quantity,
        totalPrice: (0, _helpers.formatMoneyCents)(cart.total_price)
      }, function () {
        _this4.updateNavCount();
      });
    }
  }, {
    key: 'updateNavCount',
    value: function updateNavCount() {
      var navCount = document.querySelectorAll('.js-cart-count');
      var quantity = this.state.quantity;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = navCount[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var count = _step.value;

          count.textContent = quantity;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'openCart',
    value: function openCart() {
      this.setState({
        cartIsOpen: true
      });
    }
  }, {
    key: 'closeCart',
    value: function closeCart() {
      this.setState({
        cartIsOpen: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return (0, _preact.h)(
        'div',
        { className: 'Minicart ' + (this.state.cartIsOpen ? 'opened' : '') },
        (0, _preact.h)(
          'button',
          { type: 'button', 'class': 'Minicart__close', onClick: this.closeCart },
          (0, _preact.h)(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 12 12' },
            (0, _preact.h)('path', { d: 'M11.761 10.61L7.152 6l4.61-4.61A.815.815 0 0010.608.24L6 4.848 1.39.238A.815.815 0 00.24 1.392L4.848 6l-4.61 4.61a.815.815 0 001.153 1.151L6 7.152l4.61 4.61a.815.815 0 001.151-1.153z' })
          )
        ),
        (0, _preact.h)(
          'div',
          { 'class': 'Minicart__content' },
          (0, _preact.h)(
            'div',
            { 'class': 'Minicart__heading h2' },
            'My Cart'
          ),
          this.state.items.length > 0 && (0, _preact.h)(
            'div',
            { className: 'Minicart__items' },
            this.state.items.map(function (item) {
              return (0, _preact.h)(_CartItem2.default, {
                key: item.key,
                item: item,
                addToCart: _this5.addToCart,
                updateCart: _this5.updateCart
              });
            })
          ),
          (0, _preact.h)(
            'div',
            { 'class': 'Minicart__actions' },
            (0, _preact.h)(
              'p',
              { 'class': 'Minicart__subtotal' },
              'Subtotal: ',
              (0, _preact.h)(
                'span',
                null,
                this.state.totalPrice
              )
            ),
            (0, _preact.h)(
              'a',
              { 'class': 'Minicart__checkout Btn Btn--dark', href: '/checkout' },
              'CHECKOUT'
            ),
            (0, _preact.h)(
              'button',
              { 'class': 'Minicart__cart Btn Btn--outline', onClick: this.closeCart },
              'Continue'
            )
          )
        )
      );
    }
  }]);
  return Cart;
}(_preact.Component);

document.addEventListener('DOMContentLoaded', function () {
  // Render Cart
  (0, _preact.render)((0, _preact.h)(Cart, { ref: function ref(element) {
      window.cart = element;
    } }), document.querySelector('.js-minicart'));

  var cartToggle = document.querySelector('.js-openCart');
  cartToggle.addEventListener('click', function (event) {
    event.preventDefault();
    window.cart.openCart();
  });
});